import RecapMajModaleController from './recap.maj.modale.controller';

import template from './recap.maj.modale.tpl.html';

export default {
	template: template,
	controller: RecapMajModaleController,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
};
